
	import { defineComponent } from 'vue';

	import LoadingSpinner from '@/ChildrenComponents/LoadingSpinner.vue';

    import { ITreatmentProgram } from '@/Models/ITreatmentProgram';
	import { IInternalUser } from '@/Models/IInternalUser';
	import { IFiscalYearReportSearch } from '@/Models/Report/IPhaseReport';

    import { TreatmentProgramService } from '@/Services/treatment-program-service';
    import { isUserAdmin } from '@/Services/Helper/component-permissions-helper';

	import { useUserStore } from '@/Services/Store/user-store';

	export default defineComponent({
		name: 'fiscal-year-report',
		components: { LoadingSpinner },
		props: {
			isSearching: { type: Boolean, required: true },
		},
		emits: ["search", "loading"],
		setup(): { currentUser: IInternalUser | null } {
			const userStoreInstance = useUserStore();
			return { currentUser: userStoreInstance.$state.cstInternalUser };
		},
		created() {
			this.loadLookups();
		},
		data () {
			return {
				searchDto: { year: null, programIds: [], programId: null } as IFiscalYearReportSearch,
                allPrograms: [] as ITreatmentProgram[],
				isLoading: false,
			}
		},
		methods: {
			loadLookups() {
				this.isLoading = true;
				this.$emit("loading", true);
				TreatmentProgramService.getAllTreatmentPrograms().then(response => this.allPrograms = response).finally(() => {
					this.$emit("loading", false);
					this.isLoading = false;
				});
			},
			getReportData() {
				if (this.searchDto.year) {
					this.$emit("search", this.searchDto);
				}
			}
		},
		computed: {
            userAttachedPrograms() : ITreatmentProgram[] {
                return isUserAdmin(this.currentUser?.attachedRoles ?? []) ? this.allPrograms : this.currentUser?.attachedPrograms ?? [];
            },
			fiscalYears(): { year: number, text: string }[] {
				// fiscal year runs Jul-Jun
				const now = new Date();
				const currentFiscalYear = now.getMonth() < 6 ? now.getFullYear() : now.getFullYear() + 1;
				const years = [] as { year: number, text: string }[];

				for (let i = currentFiscalYear; i > currentFiscalYear - 10; i--)
					years.push({ year: i, text: `${i - 1}-${i}` });

				return years;
			},
		},
	});
